import { onMessage } from "firebase/messaging";
import { messaging } from "../firebaseConfig.js"; // Asegúrate de importar correctamente tu configuración de Firebase

export const setupNotificationListener = () => {
  onMessage(messaging, (payload) => {
    console.log("Notificación recibida:", payload);

    // Opcional: Muestra una notificación personalizada al usuario
    if (Notification.permission === "granted") {
      new Notification(payload.notification.title, {
        body: payload.notification.body,
        icon: payload.notification.icon,
      });
    }
  });
};
